export default __webpack_public_path__ + "static/media/qrcodeimg.7268fdb7.svg";